import React from 'react';
import { Link } from 'react-router-dom';

import './PublicFooter.css'; // Import the new CSS file
import DefaultData from '../../CompanyData/DefaultData';

export default function PublicFooter() {
  return (
    <footer className="footer-container" style={{ backgroundColor: DefaultData.THEMECOLOR2 }}>
        <div className="footer-content">
            {/* Column 1: Brand Info */}
            <div className="footer-column brand-info">
 <Link to="/" className="text-decoration-none">
          <img src="/assets/images/Zotrai.png" alt={`${DefaultData.DEFAULTBRANDNAME} Logo`} style={{ height: '35px' }} />
        </Link>
                <p className="footer-tagline">{DefaultData.FOOTERSUBTITLE}</p>
                <div className="d-flex gap-2">
                    <a href={DefaultData.FACEBOOKURL} target="_blank" rel="noopener noreferrer" className="text-white px-2">
                        <i className="ri-facebook-line"></i>
                    </a>
                    <a href={DefaultData.TWITTERURL} target="_blank" rel="noopener noreferrer" className="text-white px-2">
                        <i className="ri-twitter-line"></i>
                    </a>
                    <a href={DefaultData.INSTGRAMURL} target="_blank" rel="noopener noreferrer" className="text-white px-2">
                        <i className="ri-instagram-line"></i>
                    </a>
                </div>
            </div>

            {/* Column 2: Search Links */}
            <div className="footer-column">
                <h4 className="footer-heading">Search</h4>
                <ul className="footer-links">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/features">Features</Link></li>
                    <li><Link to="/blog">Blog</Link></li>
                </ul>
            </div>

            {/* Column 3: The Company */}
            <div className="footer-column">
                <h4 className="footer-heading">The Company</h4>
                <ul className="footer-links">
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="">Terms and Conditions</Link></li>
                    <li><Link to="/">Privacy Policy</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                </ul>
            </div>

            {/* Column 4: Payments and Partners */}
            <div className="footer-column">
                <h4 className="footer-heading">Payment Methods</h4>
                <div className="payment-icons">
                    {/* Placeholder for your payment method images */}
                    <div className="payment-icon-wrapper"><img src="/assets/images/master.png" alt="Mastercard" title="Mastercard" /></div>
                    <div className="payment-icon-wrapper"><img src="/assets/images/visa.png" alt="Visa" title="Visa" /></div>
                    <div className="payment-icon-wrapper"><img src="/assets/images/Amex.png" alt="American Express" title="American Express" /></div>
                    <div className="payment-icon-wrapper">
                            <img src="/assets/images/google.png" alt="Google Pay" title="Google Pay" />
                        </div>
                        <div className="payment-icon-wrapper">
                            <img src="/assets/images/macpay.png" alt="Apple Pay" title="Apple Pay" />
                        </div>
                        <div className="payment-icon-wrapper">
                            <img src="/assets/images/shopify.png" alt="Shopify Pay" title="Shopify Pay" />
                        </div>
                </div>

                <h4 className="footer-heading partners-heading">Our Partners</h4>
                <div className="payment-icons">
                    <div className="payment-icon-wrapper">
                        <img src="/assets/images/razorpay.png" alt="Razorpay" title="Razorpay" />
                    </div>
                    <div className="payment-icon-wrapper">
                        <img src="/assets/images/IATA.png" alt="IATA" title="IATA" />
                    </div>
                </div>
            </div>
        </div>

        <div className="footer-bottom">
            <p>{DefaultData.FOOTERCOPYRIGHTS}</p>
            <ul className="footer-bottom-links">
              <li><Link to="/faq">FAQ</Link></li>
                <li><Link to="/">Terms of services</Link></li>
                <li><Link to="/">Privacy Policies</Link></li>
            </ul>
        </div>
    </footer>
  );
};